import IconClose from "app/icons/IconClose";
import cn from "app/utils/classnames";
import { REVEALED_EMPTY_CHAR } from "./oneChanceSpellingUtils";

interface LetterBoxLockedProps {
  letter: string;
  isCorrect: boolean;
  heightClass?: string;
}

// A non-interactive version of the letter box that is shown at the end of the
// round, after the player has submitted a spelling.
export default function LetterBoxLocked({
  letter,
  isCorrect,
  heightClass = "min-w-12",
}: LetterBoxLockedProps) {
  const isRevealedEmpty = letter === REVEALED_EMPTY_CHAR;

  let bgColor = "bg-white";
  if (isRevealedEmpty) {
    bgColor = "bg-white";
  } else if (isCorrect) {
    bgColor = "bg-correct";
  } else {
    bgColor = "bg-incorrect";
  }

  return (
    <div className={cn("aspect-square")}>
      <div
        className={cn(
          "relative",
          "w-full h-full",
          heightClass,
          "outline outline-black",
          "overflow-hidden",
          bgColor,
          "flex justify-center items-center",
        )}
      >
        <p // THE ACTUAL LETTER
          className={cn(
            // "border-b border-b-black",
            "font-mono text-xl text-center uppercase align-baseline",
            "h-6.5 min-w-4",
          )}
        >
          {isRevealedEmpty ? (
            <IconClose strokeWidth={0.5} width={30} height={30} />
          ) : (
            letter
          )}
        </p>
      </div>
    </div>
  );
}
